import { Component } from '@angular/core';

@Component({
  selector: 'oes-theme-ipff',
  templateUrl: './ipff.component.html',
  styleUrls: ['./ipff.component.scss']
})
export class IpffComponent {

  constructor() { }

}
